import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';

// Forces the camera to the given position on every change, imperatively,
// instead of relying solely on Canvas's declarative `camera={{position}}`
// prop — that prop only reliably applies at Canvas construction; once
// OrbitControls has taken over the camera (via makeDefault), further
// changes to the position array on a live camera aren't guaranteed to be
// picked back up on every render/remount sequence. This component is the
// single source of truth: it runs inside the Canvas, sets camera.position
// directly, points it at the origin, and re-syncs OrbitControls' internal
// state so dragging afterward doesn't snap back.
export default function CameraSync({ position, controlsRef }) {
  const { camera } = useThree();

  useEffect(() => {
    camera.position.set(position[0], position[1], position[2]);
    camera.lookAt(0, 0, 0);
    camera.updateProjectionMatrix();
    const controls = controlsRef?.current;
    if (controls) {
      controls.target.set(0, 0, 0);
      controls.update();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [position[0], position[1], position[2], camera]);

  return null;
}
